import {useEffect,useRef,useState} from "react";
export function commandOrbPhase(command,at=Date.now()){
 if(!command||command.result?.simulated)return null;
 const updated=Date.parse(command.updated_at||command.created_at||"");
 if(!Number.isFinite(updated)||updated>at+5000)return null;
 if(command.awaiting_confirmation)return null;
 if(["reclamada","ejecutando"].includes(command.status)&&at-updated<120000)return "ejecutando";
 if(at-updated>2400)return null;
 if(command.status==="confirmada"&&command.result?.ok===true)return "exito";
 if(["fallida","incierta","vencida"].includes(command.status))return "error";
 if(command.status==="cancelada")return "interrumpido";
 return null;
}
export function useOrbPhase(voiceState,commands){
 const [phase,setPhase]=useState(null),since=useRef(Date.now());
 useEffect(()=>{
  const newest=(commands||[]).find(c=>Date.parse(c.updated_at||c.created_at||"")>=since.current);
  const next=commandOrbPhase(newest);setPhase(next);
  if(!next)return;
  const timer=setTimeout(()=>setPhase(null),next==="ejecutando"?120000:2400);
  return()=>clearTimeout(timer);
 },[commands]);
 return ["hablando","escuchando","error","interrumpido"].includes(voiceState)?voiceState:phase||voiceState;
}
